import { Button, Col, Form, Row } from 'react-bootstrap';
import { FaFilter } from 'react-icons/fa';
import React from 'react';
import PropTypes from 'prop-types';

const FilterForm = ({ setFilterString, onInteraction, filterString }) => {
  if (!onInteraction) {
    onInteraction = () => null;
  }

  const inputRef = React.createRef();

  const filter = (filterText) => {
    setFilterString(inputRef.current.value);
    onInteraction();
  };

  return (
    <>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          filter(inputRef.current.value);
        }}
        id="filter-form"
      >
        <Form.Group as={Row} controlId="filter">
          <Col sm="8" style={{ margin: 'auto' }}>
            <Form.Control ref={inputRef} defaultValue={filterString} />
          </Col>
          <Col sm="4">
            <Button onClick={(ev) => filter(inputRef.current.value)}>
              <FaFilter /> Filter <b>metadata</b>
            </Button>
          </Col>
        </Form.Group>
      </Form>
    </>
  );
};

FilterForm.propTypes = {
  setFilterString: PropTypes.func,
  onInteraction: PropTypes.func,
  filterString: PropTypes.string
};

export default FilterForm;
